import React, { FC } from 'react';

import Detail from '../components/Detail';
import { EventResource } from '../models';

const LocationDetail: FC<{ event: EventResource }> = ({ event }) => {
  return <Detail icon="map-marker" text={event.attributes.location} />;
};

export default LocationDetail;
